import styled from 'styled-components';

export const BodyContainer = styled.div`
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
